exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MutilSelectVcDemo h4[data-v-338fbcd3]{color:#066}.MutilSelectVcDemo .demoItem[data-v-338fbcd3]{padding:10px 0;border-bottom:1px dotted #999}.MutilSelectVcDemo .demoItem .demoText[data-v-338fbcd3]{margin:15px 10px 5px}", ""]);

// exports
